import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return _withDirectives((_openBlock(), _createBlock("div", null, null, 512)), [
    [_directive_sanitize_html, _ctx.chipStyles]
  ])
}